import { useEffect, useRef, useState } from 'react';

export const useKeyCloakActivity = (time?: number) => {
    if (!time) return false;
    
    const [lastActivity, setLastActivity] = useState<number>(Date.now());
    const lastActivityRef = useRef(lastActivity);
    const channelRef = useRef<BroadcastChannel | null>(null);
    const INACTIVITY_TIMEOUT = time * 1000;
    const [isInactive, setIsInactive] = useState<boolean>(false);

    useEffect(() => {
        channelRef.current = new BroadcastChannel('user_activity');

        const resetTimer = () => {
            const now = Date.now();
            setLastActivity(now);
            lastActivityRef.current = now;
            if (channelRef.current) {
                try {
                    channelRef.current.postMessage({ type: 'activity', timestamp: now });
                } catch (error) {
                    console.error('Ошибка отправки в BroadcastChannel:', error);
                }
            }
        };

        const handleActivityMessage = (event: MessageEvent) => {
            if (event.data.type === 'activity') {
                setLastActivity(event.data.timestamp);
                lastActivityRef.current = event.data.timestamp;
            }
        };

        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keydown', resetTimer);
        window.addEventListener('click', resetTimer);
        channelRef.current.addEventListener('message', handleActivityMessage);

        const intervalId = setInterval(() => {
            const now = Date.now();
            if (now - lastActivityRef.current > INACTIVITY_TIMEOUT) {
                clearInterval(intervalId);
                setIsInactive(true);
            } 
        }, INACTIVITY_TIMEOUT);

        resetTimer();

        return () => {
            window.removeEventListener('mousemove', resetTimer);
            window.removeEventListener('keydown', resetTimer);
            window.removeEventListener('click', resetTimer);
            if (channelRef.current) {
                channelRef.current.removeEventListener('message', handleActivityMessage);
                channelRef.current.close();
                channelRef.current = null;
            }
            clearInterval(intervalId);
        };
    }, [time]);

    return isInactive;
};
